import { useCallback, useEffect, useState } from "react";
import { getContentAssessments } from "../services/api/assessments/assessments.api";
import { formatDate } from "../utils/formatDate";

export const normalizeAssessmentRelationDescription = (
  description = "",
  version
) => {
  if (!description) return description;

  const descriptionVersion = description.match(/-\s*v(\d+)\s*$/i)?.[1];
  const normalizedVersion = version ?? descriptionVersion;
  const normalizedDescription = description.replace(
    /Capítulo\s+(\d+)(?:\s*-\s*v\d+)?/gi,
    (_, chapterNumber) => {
      const chapter = `C${String(Number(chapterNumber)).padStart(2, "0")}`;
      return normalizedVersion == null
        ? chapter
        : `${chapter} - v${String(normalizedVersion).padStart(2, "0")}`;
    }
  );

  if (normalizedDescription !== description) return normalizedDescription;

  const episodeMatch = description.match(/^Episódio\s+(\d+)\s*-\s*(.*)$/i);
  if (episodeMatch) {
    const [, episodeNumber, remainder] = episodeMatch;
    return `E${String(Number(episodeNumber)).padStart(2, "0")} - ${remainder}`;
  }

  return description;
};

const mapAssessmentToRow = (item) => ({
  id: item.id,
  reportAttachmentId: item.reportAttachmentId,
  fileName: item.fileName,
  relation:
    item.related?.map((related) =>
      normalizeAssessmentRelationDescription(related.description, related.version)
    ) ?? [],
  receivedAt: formatDate(item.createdAt),
});

export function useCultureHubAssessments({ contentId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchItems = useCallback(() => {
    if (!contentId) return;

    setLoading(true);
    setError(null);

    return getContentAssessments({ contentId })
      .then((response) => {
        setItems(response.map(mapAssessmentToRow));
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [contentId]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  return { items, loading, error, refetch: fetchItems };
}
